import { Carousel } from "@mantine/carousel";
import { Container, Grid, Loader, Paper } from "@mantine/core";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { StatsCard } from "../../../AdminPages/Dashboard/StatsCard";
import TotalFeedback from "../../../AdminPages/Dashboard/TotalFeedback";
import { AdminPageTitle } from "../../../components/adminPageTitle";
import JobSlide from "../../../components/JobSlide/jobCard";
import { backendUrl } from "../../../constants";
import { loadJobSeekerStats } from "./loadData";

const MyDashboardStats = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState([]);
  let userId = JSON.parse(localStorage.getItem("userData"))?.id;

  useEffect(() => {
    loadJobSeekerStats(userId, setLoading).then(setStats);
  }, [location.pathname]);
  console.log("these are stats", stats);
  const dataUsers = [
    {
      value: stats?.totalPosts || 0,
      title: "Total Posts",
      icon: "user",
    },
    {
      value: stats?.totalFollowers || 0,
      title: "Total Followers",
      icon: "user",
    },
    {
      value: stats?.totalFollowings || 0,
      title: "Total Following",
      icon: "user",
    },
    {
      value: stats?.totalJobsAppliedJobs || 0,
      title: "Total Applied Jobs",
      color: "black",
      icon: "user",
    },
    {
      value: stats?.totalPendingJobs || 0,
      title: "Total Pending Jobs",
      color: "black",
      icon: "user",
    },
    {
      value: stats?.totalApprovedJobs || 0,
      title: "Total Approved Jobs",
      color: "black",
      icon: "user",
    },
  ];
  const userPieChartData = [
    {
      value: stats?.totalPendingJobs || 0,
      title: "Total Pending Jobs",
      color: "black",

      icon: "user",
    },
    {
      value: stats?.totalApprovedJobs || 0,
      title: "Total Approved Jobs",
      icon: "user",
    },
  ];
  const jobPieChartData = [
    {
      value: stats?.totalFollowers || 0,
      title: "Total Followers",
      icon: "user",
    },
    {
      value: stats?.totalFollowings || 0,
      title: "Total Followings",
      icon: "user",
    },
  ];
  return (
    <Container size={1900} mt="xl">
      <AdminPageTitle title="Job Seeker Dashboard" />
      <StatsCard data={dataUsers} cols={3} />
      <Grid mt="xl">
        <Grid.Col lg={6}>
          <TotalFeedback
            data={userPieChartData.map((item) => item.value)}
            labels={userPieChartData.map((item) => item.title)}
          />
        </Grid.Col>
        <Grid.Col lg={6}>
          <TotalFeedback
            data={jobPieChartData.map((item) => item.value)}
            labels={jobPieChartData.map((item) => item.title)}
          />
        </Grid.Col>
      </Grid>
    </Container>
  );
};

export default MyDashboardStats;
